import type { StaticDataRouteOption } from "@tanstack/react-router";

declare module "@tanstack/react-router" {
  interface StaticDataRouteOption {
    /**
     * The route's URL is itself a credential, such as a reviewer link with a
     * signed token in its path. The root layout loads no third-party script for
     * a document that opens on one: nothing that could see the URL (analytics,
     * tag managers, pixels) is ever started.
     */
    secretUrl?: boolean;
  }
}

/** `staticData` for a route whose URL is a credential. */
export const SECRET_URL = { secretUrl: true } satisfies StaticDataRouteOption;

/** Whether any matched route has declared its URL a secret. */
export function hasSecretUrl(
  matches: ReadonlyArray<{ staticData?: StaticDataRouteOption }>
): boolean {
  return matches.some((match) => match.staticData?.secretUrl === true);
}
